import { z } from "zod";

// Keep import relative for tsconfig.node compat
import { stringToBooleanSchema } from "../../../utils/zod/boolean.ts";

export const appConfigSchema = z.object({
  APP_ENV: z.enum(["local", "development", "staging", "preprod", "production"]).default("local"),

  VITE_BACKOFFICE_BASE_URL: z.string().url(),
  VITE_BACKOFFICE_VALIDATE_RESPONSE: stringToBooleanSchema,
  VITE_SHOULD_AUTHENTICATE_USING_CAPTCHA: stringToBooleanSchema,
  VITE_GOOGLE_CAPTCHA_SITE_KEY: z.string(),
  VITE_VOLTEXPLOIT_SERVICE_ID: z.coerce.number(),

  VITE_TANSTACK_GLOBAL_STALE_TIME: z.coerce.number(),
  VITE_TANSTACK_REFETCH_ON_MOUNT: z.enum(["always", "true", "false"]).transform((arg) => {
    if (arg === "always") {
      return "always";
    }

    if (arg === "true") {
      return true;
    }

    return false;
  }),
  VITE_VOLTACALL_BASE_URL: z.string().url(),
  VITE_SENTRY_ENABLED: stringToBooleanSchema,
  VITE_SENTRY_DSN: z.string().url(),
  VITE_SENTRY_TRACES_SAMPLE_RATE: z.coerce.number().positive().min(0).max(1),
});

export type TAppConfig = z.infer<typeof appConfigSchema>;
